import { CLUSTER, IS_DEVELOP_FEATURE } from '@/shared/config';

import { TRANSCRIPTOR_LANGUAGE } from '@/entities/transcriptor';

import { RecordingMethod, TranscriptorPreferences } from './types';

export const TRANSCRIPTOR_PREFERENCES_KEY = 'transcriptorRecordingPreferences';

export const DEFAULT_TRANSCRIPTOR_LANGUAGE =
  CLUSTER === 'ru' || IS_DEVELOP_FEATURE
    ? TRANSCRIPTOR_LANGUAGE.Russian
    : TRANSCRIPTOR_LANGUAGE.English;

export const DEFAULT_TRANSCRIPTOR_PREFERENCES: TranscriptorPreferences = {
  schemaId: '',
  templateSeriesIds: [],
  recordingMethod: RecordingMethod.Record,
  language: DEFAULT_TRANSCRIPTOR_LANGUAGE,
};
